/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Dot Icon
 *
 * @file DotIcon.jsx
 * @author Gladson Samuel S
 * @since 0.0.1
 */

import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@mui/material/SvgIcon';

const dotIconSx = {
  width: 6,
  height: 6,
  fontSize: 6
};

const getSxArray = (sxValue) => {
  if (!sxValue) {
    return [];
  }

  if (Array.isArray(sxValue)) {
    return sxValue;
  }

  return [sxValue];
};

const DotIcon = ({ className, sx, ...rest }) => (
  <SvgIcon
    {...rest}
    className={className}
    viewBox="0 0 6 6"
    sx={[dotIconSx, ...getSxArray(sx)]}
  >
    <circle cx="3" cy="3" r="3" fill="currentColor" />
  </SvgIcon>
);

DotIcon.propTypes = {
  className: PropTypes.string,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func])
};

DotIcon.defaultProps = {
  className: undefined,
  sx: undefined
};

export default DotIcon;
